export default "__VITE_ASSET__Dga$5QHp__"